// quantity-sync.js
// Fixes Dawn's FormData quantity bug.
// The Dawn quantity-input lives OUTSIDE the <form> tag (linked via form= attr).
// FormData only picks up inputs physically inside the form, so we inject a
// hidden quantity field inside the form and keep it synced to the visible input.
//
// NOTE: form.id returns the child <input name="id"> element due to a browser
// quirk, so we always use form.getAttribute('id') to get the actual id string.
//
// If a third-party app (GemPages, Globo etc.) injects its own type=number
// name=quantity inside the form, we remove our hidden field to avoid conflict.
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(function (form) {
    var qHidden = form.querySelector('input[type="hidden"][name="quantity"]');
    if (!qHidden) return;

    // Third-party app already has a visible quantity field inside this form
    // — remove ours to avoid the duplicate-field conflict.
    var thirdPartyQty = form.querySelector('input[type="number"][name="quantity"]');
    if (thirdPartyQty) {
      qHidden.parentNode.removeChild(qHidden);
      return;
    }

    // getAttribute avoids the browser quirk where form.id returns a child element.
    var formId = form.getAttribute('id') || '';
    var sectionId = formId.replace('product-form-', '');
    if (!sectionId) return;

    var qInput = document.getElementById('Quantity-' + sectionId);
    if (!qInput) return;

    function syncQty() { qHidden.value = qInput.value; }
    qInput.addEventListener('change', syncQty);
    qInput.addEventListener('input', syncQty);
  });
});
